import axios from "axios";

const PREPEND_ROUTE = '/rest/v4/';

export default {
    getData(path) {
        return (config) => axios.get(`${PREPEND_ROUTE}${path}`, config)
    },
}
